import { getTestIds } from 'seagull/utils/TestIds';
export const GetImportClientsModalTID = (parentTestId)=>getTestIds(parentTestId);
export const isNothingToImport = (param)=>{
    let { customersCreated, contactsAdded, failures, customersWithSaveErrors, unreadableRows } = param;
    return customersCreated === 0 && contactsAdded === 0 && failures.length === 0 && customersWithSaveErrors.length === 0 && unreadableRows.length === 0;
};
export const actionsFor = (mode, deps)=>{
    const { dismissModal, backToUpload, texts, testId } = deps;
    const { ImportClientsModalTestIds } = GetImportClientsModalTID(testId);
    const retryActions = {
        primaryLabel: texts.actions.uploadAnotherFile(),
        primaryTestId: ImportClientsModalTestIds.UploadAnotherFileButton(),
        onPrimary: backToUpload,
        primaryBi: 'import_clients_upload_another',
        secondaryLabel: texts.actions.close(),
        secondaryTestId: ImportClientsModalTestIds.CloseButton(),
        onSecondary: dismissModal,
        secondaryBi: 'import_clients_close'
    };
    const closeOnlyActions = {
        secondaryLabel: texts.actions.close(),
        secondaryTestId: ImportClientsModalTestIds.CloseButton(),
        onSecondary: dismissModal,
        primaryBi: 'import_clients_primary_noop',
        secondaryBi: 'import_clients_close'
    };
    if (mode.kind === 'result') return isNothingToImport(mode.response) ? retryActions : closeOnlyActions;
    if (mode.kind === 'blockingError') return mode.errorKind === 'missingColumns' ? closeOnlyActions : retryActions;
    return {
        primaryBi: 'import_clients_primary_noop',
        secondaryBi: 'import_clients_secondary_noop'
    };
};
